export default "__VITE_ASSET__C0S8Fgor__"